import React from "react";
import BarChart2 from "@/components/BarChart2";

const metricClassName =
  "text-xs bg-white whitespace-nowrap text-gray-700 font-semibold py-2 px-2 border-gray-400 rounded-lg shadow-lg shadow-slate-300";

const FirstAsset = ({ firstAssetName, assetArray }) => {
  return (
    <div className="grid grid-cols-12 gap-2 sm:gap-5 mb-4">
      <div className="col-span-12 sm:col-span-7">
        <div className="bg-white rounded-lg shadow-xl shadow-slate-300 p-5">
          <BarChart2
            min={assetArray?.min}
            max={assetArray?.max}
            average={assetArray?.average}
          />
        </div>
      </div>
      <div className="col-span-12 sm:col-span-5 gap-3 flex md:block items-center">
        <div className="mb-0 sm:mb-2">{firstAssetName}</div>
        <div className="flex gap-2 flex-row">
          <span className={metricClassName}>
            {`AM: ${parseFloat(assetArray?.am).toFixed(1)}%`}
          </span>
          <span className={metricClassName}>
            {`GM: ${parseFloat(assetArray?.gm).toFixed(1)}%`}
          </span>
        </div>
      </div>
    </div>
  );
};

export default FirstAsset;
